import React from "react"
import { Accordion, Card } from "react-bootstrap"

interface AccordionCardProps {
  eventKey: string
  title: JSX.Element | string
  children?: React.ReactNode
}
export default function AccordionCard(props: AccordionCardProps) {
  return (
    <Card>
      <Accordion.Toggle as={Card.Header} eventKey={props.eventKey} className="test-property">{props.title}</Accordion.Toggle>
      <Accordion.Collapse eventKey={props.eventKey}>
        <Card.Body>
          {props.children}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  )
}
